export class Logger {
  private debugLevel: boolean;

  constructor(debugLevel = false) {
    this.debugLevel = debugLevel;
  }

  setDebugLevel(debugLevel: boolean) {
    this.debugLevel = debugLevel;
  }

  log(...messages: any[]) {
    console.log("[Logger info]:", ...messages);
  }

  info(...messages: any[]) {
    this.log(...messages);
  }

  debug(...messages: any[]) {
    if (this.debugLevel) {
      console.debug("[Logger debug]:", ...messages);
    }
  }
}
